import { render } from "./amoozeshi.vue?vue&type=template&id=7b201339"
import script from "./amoozeshi.vue?vue&type=script&lang=js"
export * from "./amoozeshi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__